import { Data } from './types';
import {
    FETCH_LIST_CART_REQUEST,
    FETCH_LIST_CART_SUCCESS,
    FETCH_LIST_CART_ERROR,
    UPDATE_CART_LIST,
    UPDATE_CART_REQUEST,
    UPDATE_CART_SUCCESS,
    UPDATE_CART_ERROR,
    FETCH_COUNT_CART_REQUEST,
    FETCH_COUNT_CART_SUCCESS,
    FETCH_COUNT_CART_ERROR,
    RESET_COUNT_CART,
} from './actions';
import { AnyObject } from 'yup';
import { ActionTypeEnumCart } from 'core/config/constant';

export interface DataState {
    dataList: Data[];
    dataDetail: AnyObject;
    loading: boolean;
    error: Error | null;
    countCart: number;
    loadingUpdate: boolean;
    loadingCount: boolean;
    lastPage: number;
}

const initialState: DataState = {
    dataList: [],
    dataDetail: {},
    countCart: 0,
    loading: false,
    error: null,
    loadingUpdate: false,
    loadingCount: false,
    lastPage: 0,
};

const cartReducer = (
    state: DataState = initialState,
    action: any,
): DataState => {
    switch (action.type) {
        case FETCH_LIST_CART_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_LIST_CART_SUCCESS:
            {
                let listData = state.dataList.concat(action.payload.data)

                if (action.payload?.current_page === 1) {
                    listData = action.payload.data
                }
                const listDataMap = listData.map((item: any) => {
                    const newObject = {
                        ...item,
                        name: item.translates[0].name
                    };
                    return newObject
                })
                return {
                    ...state,
                    dataList: listDataMap,
                    loading: false,
                    error: null,
                    lastPage: action.payload?.last_page
                };
            }
        case FETCH_LIST_CART_ERROR:
            return { ...state, loading: false, error: action.payload };
        case UPDATE_CART_REQUEST:
            {
                const type = action?.payload?.action
                let updateCart = Number(state?.countCart)
                if ([ActionTypeEnumCart.REMOVE].includes(type)) {
                    updateCart = updateCart - 1
                } else {
                    updateCart = updateCart + 1
                }
                return {
                    ...state,
                    loadingUpdate: true,
                    error: null,
                    countCart: updateCart,
                };
            }
        case UPDATE_CART_SUCCESS:
            {
                return {
                    ...state,
                    dataDetail: action.payload,
                    error: null,
                    loadingUpdate: false
                };
            }
        case UPDATE_CART_ERROR:
            return { ...state, loadingUpdate: false, error: action.payload };
        case UPDATE_CART_LIST:
            return { ...state, dataList: action?.payload };
        case FETCH_COUNT_CART_REQUEST:
            return { ...state, loadingCount: true, error: null };
        case FETCH_COUNT_CART_SUCCESS:
            return { ...state, countCart: action.payload?.count, loadingCount: false, error: null };
        case FETCH_COUNT_CART_ERROR:
            return { ...state, loadingCount: false, error: action.payload };
        case RESET_COUNT_CART:
            return { ...state, countCart: 0 };
        default:
            return state;
    }
};

export default cartReducer
